import { FamilyMemberFields } from './familyMember.models';

export const familyMembersAddressInformationsInitState = {
  [FamilyMemberFields.AddressSameAsPrimaryMemberResidenceAddress]: true,
  [FamilyMemberFields.ResidenceAddress]: {},
};
